import { appVersion } from './app-version';

export const environment = {
    production: false,
    envName: "stage",
    apiUrl: 'https://services.untracked-ita.com/api/v1',
    googleMapsApiKey: 'AIzaSyBM-I5hNyT_l4Au5HwBw4ejYdyAVON29Oo',
    s3BucketUrl: 'https://untrackedtrips-it-travels-fe-s3-stage.s3.eu-central-1.amazonaws.com',
    cfTravelUrl: 'https://travel-stage.untrackedtrips.it',
    linguiseApiScriptUrl: 'https://static.linguise.com/script-js/switcher.bundle.js?d=pk_gnFiLclTBsZKiEUH1Ru3OQ5JgwL7surC',
    chatbotApiUrl: 'https://orygofrontend-production.up.railway.app/api/embed/c022bb39-598c-467c-9370-31aedeba8f10/widget.js',
    appVersion

};